import { Renderer } from '@unseenco/taxi'
import { isDEVMODE, viewStorage, domStorage } from '../_globals'
import WknSwiper from '../modules/wkn-swiper'
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import Form from "../modules/form";
gsap.registerPlugin(ScrollTrigger)

export default class PageHome extends Renderer {

  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  }

  onEnter() {
    this.DOM = {
      hero: viewStorage.current.querySelector('.Homepage__hero__background'),
      texts: viewStorage.current.querySelectorAll('.Page__text .content p'),
      featuredPostsSwiper: viewStorage.current.querySelector('.FeaturedPosts__swiper'),
      contactForm: viewStorage.current.querySelector('.Form'),
    }

    this.init()
  }

  init() {
    const { contactForm } = this.DOM
    !domStorage.header.classList.contains('--light') && domStorage.header.classList.add('--light')

    this.initScrollTriggerInit()
    this.initPrizesSwiper()
    this.initTextReveal()
    this.initFeaturedPostsSwiper()

    if (contactForm) this.contactForm = new Form(contactForm)
  }

  initScrollTriggerInit() {
    if(!this.DOM.hero) {
      return
    }

    this.scrollTrigger = ScrollTrigger.create({
      trigger: this.DOM.hero,
      start: 'top bottom',
      end: 'bottom top',
      onLeave: () => {
        domStorage.header.classList.contains('--light') && domStorage.header.classList.remove('--light')
      },
      onEnterBack: () => {
        !domStorage.header.classList.contains('--light') && domStorage.header.classList.add('--light')
      }
    })
  }

  initPrizesSwiper() {
    this.swiperPrizes = new WknSwiper(
      viewStorage.current.querySelector('.Prizes__swiper'),
      viewStorage.current.querySelector('.Prizes__header__buttons'),
      {
        slidesPerView: 1.4,
        spaceBetween: 12,

        breakpoints: {
          1024: {
            slidesPerView: 2.3,
            spaceBetween: 16,
          },
          1440: {
            slidesPerView: 3.6,
            spaceBetween: 16,
          },
        }
      }
    )
  }

  initTextReveal() {
    if(this.DOM.texts.length === 0) {
      return
    }

    this.textAnims = []

    this.DOM.texts.forEach(item => {

      item.textsplit = new SplitText(item, {type: 'words', wordsClass: 'word__wrapper'})
      item.textsplitwords = new SplitText(item, {type: 'words', wordsClass: 'word'})

      item.textanimTL = gsap.timeline({ paused: true, immediateRender: true })
      item.textanimTL.fromTo(item.textsplitwords.words, { yPercent: 120 }, { yPercent: 0, stagger: 0.02, duration: 1, ease: 'power4.out' }, 0)

      item.textanimST = new ScrollTrigger.create({
        trigger: item,
        // markers: isDEVMODE,
        start: 'top bottom-=20%',
        once: true,
        onEnter: () => item.textanimTL.restart()
      })

      this.textAnims.push(item)

    })
  }

  initFeaturedPostsSwiper() {
    if (!this.DOM.featuredPostsSwiper) return

    this.featuredPostsSwiper = new WknSwiper(
      this.DOM.featuredPostsSwiper,
      this.DOM.featuredPostsSwiper.querySelector('.swiper-navigation'),
      {
        slidesPerView: 'auto',
        spaceBetween: 16,
      }
    )
  }

  onLeaveCompleted() {
    if (this.swiperPrizes) {
      this.swiperPrizes.destroy()
    }

    this.scrollTrigger && this.scrollTrigger.kill(true)

    domStorage.header.classList.contains('--light') && domStorage.header.classList.remove('--light')

    this.textAnims.forEach(item => {
      item.textsplit = null
      item.textsplitwords = null
      item.textanimTL.kill(true)
      item.textanimST.kill(true)
    })

    if (this.featuredPostsSwiper) {
      this.featuredPostsSwiper.destroy()
    }
  }
}
